export interface SyncEngineState {
  syncRetrying: boolean;
  syncErrorMessage: string | null;
  syncIsolatedFailure?: unknown | null;
}

export function shouldShowGlobalSyncRetryStatus(
  state: SyncEngineState | null | undefined
): boolean {
  return (
    state != null &&
    state.syncRetrying === true &&
    state.syncIsolatedFailure == null
  );
}

export function shouldShowGlobalSyncOfflineBanner(
  state: SyncEngineState | null | undefined,
  docSyncWasEstablished: boolean
): boolean {
  return (
    state != null &&
    shouldShowGlobalSyncRetryStatus(state) &&
    docSyncWasEstablished &&
    !!state?.syncErrorMessage
  );
}
